/**
 * B Book LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Update pair setting request.
 */
export interface UpdatePairSettingRequest {
  assetId: number;
  maxSize: number;
  maxPosition: number;
  /**
   * In USD
   */
  maxLoss: number;
  /**
   * Reset loss or not
   */
  resetLoss: boolean;
  /**
   * Try to close position automatically when max loss happen
   */
  autoClosePositionOnMaxLoss: boolean;
  /**
   * Reduce position automatically to 50% of max position.
   */
  autoReducePosition: boolean;
}
